import { Box } from 'ui/components/Box'
import { makeComponent } from 'ui/helpers/recipes'

import { AttributeStyles, CardStyles, ColumnHeaderStyles, ColumnStyles } from './BoardView.css'

export const Column = makeComponent(Box, ColumnStyles)
export const ColumnHeader = makeComponent(Box, ColumnHeaderStyles)
export const Card = makeComponent(Box, CardStyles)
export const Attribute = makeComponent(Box, AttributeStyles)
